/**
 * Created by ctsi-biyi-generator
 */
export default {
  'zh-CN': {
    'supportDataInfo.id.label': 'id',
    'supportDataInfo.id.holder': '请输入id',
    'supportDataInfo.id.max': 'id最多10个字符',
    'supportDataInfo.id.required': 'id必填',
    'supportDataInfo.searchId.holder': '搜索id',
    'supportDataInfo.name.label': 'name',
    'supportDataInfo.name.holder': '请输入name',
    'supportDataInfo.name.max': 'name最多200个字符',
    'supportDataInfo.name.required': 'name必填',
    'supportDataInfo.searchName.holder': '搜索name',
    'supportDataInfo.dataDesc.label': 'dataDesc',
    'supportDataInfo.dataDesc.holder': '请输入dataDesc',
    'supportDataInfo.dataDesc.max': 'dataDesc最多500个字符',
    'supportDataInfo.dataDesc.required': 'dataDesc必填',
    'supportDataInfo.searchDataDesc.holder': '搜索dataDesc',
    'supportDataInfo.createTime.label': 'createTime',
    'supportDataInfo.createTime.holder': '请输入createTime',
    'supportDataInfo.createTime.max': 'createTime最多23个字符',
    'supportDataInfo.createTime.required': 'createTime必填',
    'supportDataInfo.searchCreateTime.holder': '搜索createTime',
    'supportDataInfo.remark.label': 'remark',
    'supportDataInfo.remark.holder': '请输入remark',
    'supportDataInfo.remark.max': 'remark最多200个字符',
    'supportDataInfo.remark.required': 'remark必填',
    'supportDataInfo.searchRemark.holder': '搜索remark',
    'supportDataInfo.businessId.label': 'businessId',
    'supportDataInfo.businessId.holder': '请输入businessId',
    'supportDataInfo.businessId.max': 'businessId最多10个字符',
    'supportDataInfo.businessId.required': 'businessId必填',
    'supportDataInfo.searchBusinessId.holder': '搜索businessId',
    'supportDataInfo.type.label': 'type',
    'supportDataInfo.type.holder': '请输入type',
    'supportDataInfo.type.max': 'type最多20个字符',
    'supportDataInfo.type.required': 'type必填',
    'supportDataInfo.searchType.holder': '搜索type',
    'supportDataInfo.sort.label': 'sort',
    'supportDataInfo.sort.holder': '请输入sort',
    'supportDataInfo.sort.max': 'sort最多10个字符',
    'supportDataInfo.sort.required': 'sort必填',
    'supportDataInfo.searchSort.holder': '搜索sort',
    'supportDataInfo.class.label': 'class',
    'supportDataInfo.class.holder': '请输入class',
    'supportDataInfo.class.max': 'class最多1个字符',
    'supportDataInfo.class.required': 'class必填',
    'supportDataInfo.searchClass.holder': '搜索class',
    'supportDataInfo.dataType.label': 'dataType',
    'supportDataInfo.dataType.holder': '请输入dataType',
    'supportDataInfo.dataType.max': 'dataType最多255个字符',
    'supportDataInfo.dataType.required': 'dataType必填',
    'supportDataInfo.searchDataType.holder': '搜索dataType',
    'supportDataInfo.tableName.label': 'tableName',
    'supportDataInfo.tableName.holder': '请输入tableName',
    'supportDataInfo.tableName.max': 'tableName最多255个字符',
    'supportDataInfo.tableName.required': 'tableName必填',
    'supportDataInfo.searchTableName.holder': '搜索tableName',
    'supportDataInfo.sql.label': 'sql',
    'supportDataInfo.sql.holder': '请输入sql',
    'supportDataInfo.sql.max': 'sql最多8,000个字符',
    'supportDataInfo.sql.required': 'sql必填',
    'supportDataInfo.searchSql.holder': '搜索sql',
    'supportDataInfo.visitCn.label': 'visitCn',
    'supportDataInfo.visitCn.holder': '请输入visitCn',
    'supportDataInfo.visitCn.max': 'visitCn最多10个字符',
    'supportDataInfo.visitCn.required': 'visitCn必填',
    'supportDataInfo.searchVisitCn.holder': '搜索visitCn',
    'supportDataInfo.apiName.label': 'apiName',
    'supportDataInfo.apiName.holder': '请输入apiName',
    'supportDataInfo.apiName.max': 'apiName最多255个字符',
    'supportDataInfo.apiName.required': 'apiName必填',
    'supportDataInfo.searchApiName.holder': '搜索apiName',
    'supportDataInfo.sysId.label': 'sysId',
    'supportDataInfo.sysId.holder': '请输入sysId',
    'supportDataInfo.sysId.max': 'sysId最多50个字符',
    'supportDataInfo.sysId.required': 'sysId必填',
    'supportDataInfo.searchSysId.holder': '搜索sysId',
    'supportDataInfo.apiname.label': 'apiname',
    'supportDataInfo.apiname.holder': '请输入apiname',
    'supportDataInfo.apiname.max': 'apiname最多50个字符',
    'supportDataInfo.apiname.required': 'apiname必填',
    'supportDataInfo.searchApiname.holder': '搜索apiname',
    'supportDataInfo.isShow.label': 'isShow',
    'supportDataInfo.isShow.holder': '请输入isShow',
    'supportDataInfo.isShow.max': 'isShow最多10个字符',
    'supportDataInfo.isShow.required': 'isShow必填',
    'supportDataInfo.searchIsShow.holder': '搜索isShow',
    'supportDataInfo.qu.label': 'qu',
    'supportDataInfo.qu.holder': '请输入qu',
    'supportDataInfo.qu.max': 'qu最多50个字符',
    'supportDataInfo.qu.required': 'qu必填',
    'supportDataInfo.searchQu.holder': '搜索qu',
    'supportDataInfo.isPage.label': 'isPage',
    'supportDataInfo.isPage.holder': '请输入isPage',
    'supportDataInfo.isPage.max': 'isPage最多10个字符',
    'supportDataInfo.isPage.required': 'isPage必填',
    'supportDataInfo.searchIsPage.holder': '搜索isPage',
    'supportDataInfo.procId.label': 'procId',
    'supportDataInfo.procId.holder': '请输入procId',
    'supportDataInfo.procId.max': 'procId最多10个字符',
    'supportDataInfo.procId.required': 'procId必填',
    'supportDataInfo.searchProcId.holder': '搜索procId',
    'supportDataInfo.browseNum.label': 'browseNum',
    'supportDataInfo.browseNum.holder': '请输入browseNum',
    'supportDataInfo.browseNum.max': 'browseNum最多10个字符',
    'supportDataInfo.browseNum.required': 'browseNum必填',
    'supportDataInfo.searchBrowseNum.holder': '搜索browseNum',
    'supportDataInfo.downNum.label': 'downNum',
    'supportDataInfo.downNum.holder': '请输入downNum',
    'supportDataInfo.downNum.max': 'downNum最多10个字符',
    'supportDataInfo.downNum.required': 'downNum必填',
    'supportDataInfo.searchDownNum.holder': '搜索downNum',
    'supportDataInfo.visitNum.label': 'visitNum',
    'supportDataInfo.visitNum.holder': '请输入visitNum',
    'supportDataInfo.visitNum.max': 'visitNum最多10个字符',
    'supportDataInfo.visitNum.required': 'visitNum必填',
    'supportDataInfo.searchVisitNum.holder': '搜索visitNum'
  },
  'zh-TW': {
    'supportDataInfo.id.label': 'id',
    'supportDataInfo.id.holder': '請輸入id',
    'supportDataInfo.id.max': 'id最多10個字符',
    'supportDataInfo.id.required': 'id必填',
    'supportDataInfo.searchId.holder': '搜索id',

    'supportDataInfo.name.label': 'name',
    'supportDataInfo.name.holder': '請輸入name',
    'supportDataInfo.name.max': 'name最多200個字符',
    'supportDataInfo.name.required': 'name必填',
    'supportDataInfo.searchName.holder': '搜索name',

    'supportDataInfo.dataDesc.label': 'dataDesc',
    'supportDataInfo.dataDesc.holder': '請輸入dataDesc',
    'supportDataInfo.dataDesc.max': 'dataDesc最多500個字符',
    'supportDataInfo.dataDesc.required': 'dataDesc必填',
    'supportDataInfo.searchDataDesc.holder': '搜索dataDesc',

    'supportDataInfo.createTime.label': 'createTime',
    'supportDataInfo.createTime.holder': '請輸入createTime',
    'supportDataInfo.createTime.max': 'createTime最多23個字符',
    'supportDataInfo.createTime.required': 'createTime必填',
    'supportDataInfo.searchCreateTime.holder': '搜索createTime',

    'supportDataInfo.remark.label': 'remark',
    'supportDataInfo.remark.holder': '請輸入remark',
    'supportDataInfo.remark.max': 'remark最多200個字符',
    'supportDataInfo.remark.required': 'remark必填',
    'supportDataInfo.searchRemark.holder': '搜索remark',

    'supportDataInfo.businessId.label': 'businessId',
    'supportDataInfo.businessId.holder': '請輸入businessId',
    'supportDataInfo.businessId.max': 'businessId最多10個字符',
    'supportDataInfo.businessId.required': 'businessId必填',
    'supportDataInfo.searchBusinessId.holder': '搜索businessId',

    'supportDataInfo.type.label': 'type',
    'supportDataInfo.type.holder': '請輸入type',
    'supportDataInfo.type.max': 'type最多20個字符',
    'supportDataInfo.type.required': 'type必填',
    'supportDataInfo.searchType.holder': '搜索type',

    'supportDataInfo.sort.label': 'sort',
    'supportDataInfo.sort.holder': '請輸入sort',
    'supportDataInfo.sort.max': 'sort最多10個字符',
    'supportDataInfo.sort.required': 'sort必填',
    'supportDataInfo.searchSort.holder': '搜索sort',

    'supportDataInfo.class.label': 'class',
    'supportDataInfo.class.holder': '請輸入class',
    'supportDataInfo.class.max': 'class最多1個字符',
    'supportDataInfo.class.required': 'class必填',
    'supportDataInfo.searchClass.holder': '搜索class',

    'supportDataInfo.dataType.label': 'dataType',
    'supportDataInfo.dataType.holder': '請輸入dataType',
    'supportDataInfo.dataType.max': 'dataType最多255個字符',
    'supportDataInfo.dataType.required': 'dataType必填',
    'supportDataInfo.searchDataType.holder': '搜索dataType',

    'supportDataInfo.tableName.label': 'tableName',
    'supportDataInfo.tableName.holder': '請輸入tableName',
    'supportDataInfo.tableName.max': 'tableName最多255個字符',
    'supportDataInfo.tableName.required': 'tableName必填',
    'supportDataInfo.searchTableName.holder': '搜索tableName',

    'supportDataInfo.sql.label': 'sql',
    'supportDataInfo.sql.holder': '請輸入sql',
    'supportDataInfo.sql.max': 'sql最多8,000個字符',
    'supportDataInfo.sql.required': 'sql必填',
    'supportDataInfo.searchSql.holder': '搜索sql',

    'supportDataInfo.visitCn.label': 'visitCn',
    'supportDataInfo.visitCn.holder': '請輸入visitCn',
    'supportDataInfo.visitCn.max': 'visitCn最多10個字符',
    'supportDataInfo.visitCn.required': 'visitCn必填',
    'supportDataInfo.searchVisitCn.holder': '搜索visitCn',

    'supportDataInfo.apiName.label': 'apiName',
    'supportDataInfo.apiName.holder': '請輸入apiName',
    'supportDataInfo.apiName.max': 'apiName最多255個字符',
    'supportDataInfo.apiName.required': 'apiName必填',
    'supportDataInfo.searchApiName.holder': '搜索apiName',

    'supportDataInfo.sysId.label': 'sysId',
    'supportDataInfo.sysId.holder': '請輸入sysId',
    'supportDataInfo.sysId.max': 'sysId最多50個字符',
    'supportDataInfo.sysId.required': 'sysId必填',
    'supportDataInfo.searchSysId.holder': '搜索sysId',

    'supportDataInfo.apiname.label': 'apiname',
    'supportDataInfo.apiname.holder': '請輸入apiname',
    'supportDataInfo.apiname.max': 'apiname最多50個字符',
    'supportDataInfo.apiname.required': 'apiname必填',
    'supportDataInfo.searchApiname.holder': '搜索apiname',

    'supportDataInfo.isShow.label': 'isShow',
    'supportDataInfo.isShow.holder': '請輸入isShow',
    'supportDataInfo.isShow.max': 'isShow最多10個字符',
    'supportDataInfo.isShow.required': 'isShow必填',
    'supportDataInfo.searchIsShow.holder': '搜索isShow',

    'supportDataInfo.qu.label': 'qu',
    'supportDataInfo.qu.holder': '請輸入qu',
    'supportDataInfo.qu.max': 'qu最多50個字符',
    'supportDataInfo.qu.required': 'qu必填',
    'supportDataInfo.searchQu.holder': '搜索qu',

    'supportDataInfo.isPage.label': 'isPage',
    'supportDataInfo.isPage.holder': '請輸入isPage',
    'supportDataInfo.isPage.max': 'isPage最多10個字符',
    'supportDataInfo.isPage.required': 'isPage必填',
    'supportDataInfo.searchIsPage.holder': '搜索isPage',

    'supportDataInfo.procId.label': 'procId',
    'supportDataInfo.procId.holder': '請輸入procId',
    'supportDataInfo.procId.max': 'procId最多10個字符',
    'supportDataInfo.procId.required': 'procId必填',
    'supportDataInfo.searchProcId.holder': '搜索procId',

    'supportDataInfo.browseNum.label': 'browseNum',
    'supportDataInfo.browseNum.holder': '請輸入browseNum',
    'supportDataInfo.browseNum.max': 'browseNum最多10個字符',
    'supportDataInfo.browseNum.required': 'browseNum必填',
    'supportDataInfo.searchBrowseNum.holder': '搜索browseNum',

    'supportDataInfo.downNum.label': 'downNum',
    'supportDataInfo.downNum.holder': '請輸入downNum',
    'supportDataInfo.downNum.max': 'downNum最多10個字符',
    'supportDataInfo.downNum.required': 'downNum必填',
    'supportDataInfo.searchDownNum.holder': '搜索downNum',

    'supportDataInfo.visitNum.label': 'visitNum',
    'supportDataInfo.visitNum.holder': '請輸入visitNum',
    'supportDataInfo.visitNum.max': 'visitNum最多10個字符',
    'supportDataInfo.visitNum.required': 'visitNum必填',
    'supportDataInfo.searchVisitNum.holder': '搜索visitNum'

  },
  'en-US': {
    'supportDataInfo.id.label': 'id',
    'supportDataInfo.id.holder': 'Enter id',
    'supportDataInfo.id.max': 'id max length: 10',
    'supportDataInfo.id.required': 'id required',
    'supportDataInfo.searchId.holder': 'Search id',
    'supportDataInfo.name.label': 'name',
    'supportDataInfo.name.holder': 'Enter name',
    'supportDataInfo.name.max': 'name max length: 200',
    'supportDataInfo.name.required': 'name required',
    'supportDataInfo.searchName.holder': 'Search name',
    'supportDataInfo.dataDesc.label': 'dataDesc',
    'supportDataInfo.dataDesc.holder': 'Enter dataDesc',
    'supportDataInfo.dataDesc.max': 'dataDesc max length: 500',
    'supportDataInfo.dataDesc.required': 'dataDesc required',
    'supportDataInfo.searchDataDesc.holder': 'Search dataDesc',
    'supportDataInfo.createTime.label': 'createTime',
    'supportDataInfo.createTime.holder': 'Enter createTime',
    'supportDataInfo.createTime.max': 'createTime max length: 23',
    'supportDataInfo.createTime.required': 'createTime required',
    'supportDataInfo.searchCreateTime.holder': 'Search createTime',
    'supportDataInfo.remark.label': 'remark',
    'supportDataInfo.remark.holder': 'Enter remark',
    'supportDataInfo.remark.max': 'remark max length: 200',
    'supportDataInfo.remark.required': 'remark required',
    'supportDataInfo.searchRemark.holder': 'Search remark',
    'supportDataInfo.businessId.label': 'businessId',
    'supportDataInfo.businessId.holder': 'Enter businessId',
    'supportDataInfo.businessId.max': 'businessId max length: 10',
    'supportDataInfo.businessId.required': 'businessId required',
    'supportDataInfo.searchBusinessId.holder': 'Search businessId',
    'supportDataInfo.type.label': 'type',
    'supportDataInfo.type.holder': 'Enter type',
    'supportDataInfo.type.max': 'type max length: 20',
    'supportDataInfo.type.required': 'type required',
    'supportDataInfo.searchType.holder': 'Search type',
    'supportDataInfo.sort.label': 'sort',
    'supportDataInfo.sort.holder': 'Enter sort',
    'supportDataInfo.sort.max': 'sort max length: 10',
    'supportDataInfo.sort.required': 'sort required',
    'supportDataInfo.searchSort.holder': 'Search sort',
    'supportDataInfo.class.label': 'class',
    'supportDataInfo.class.holder': 'Enter class',
    'supportDataInfo.class.max': 'class max length: 1',
    'supportDataInfo.class.required': 'class required',
    'supportDataInfo.searchClass.holder': 'Search class',
    'supportDataInfo.dataType.label': 'dataType',
    'supportDataInfo.dataType.holder': 'Enter dataType',
    'supportDataInfo.dataType.max': 'dataType max length: 255',
    'supportDataInfo.dataType.required': 'dataType required',
    'supportDataInfo.searchDataType.holder': 'Search dataType',
    'supportDataInfo.tableName.label': 'tableName',
    'supportDataInfo.tableName.holder': 'Enter tableName',
    'supportDataInfo.tableName.max': 'tableName max length: 255',
    'supportDataInfo.tableName.required': 'tableName required',
    'supportDataInfo.searchTableName.holder': 'Search tableName',
    'supportDataInfo.sql.label': 'sql',
    'supportDataInfo.sql.holder': 'Enter sql',
    'supportDataInfo.sql.max': 'sql max length: 8,000',
    'supportDataInfo.sql.required': 'sql required',
    'supportDataInfo.searchSql.holder': 'Search sql',
    'supportDataInfo.visitCn.label': 'visitCn',
    'supportDataInfo.visitCn.holder': 'Enter visitCn',
    'supportDataInfo.visitCn.max': 'visitCn max length: 10',
    'supportDataInfo.visitCn.required': 'visitCn required',
    'supportDataInfo.searchVisitCn.holder': 'Search visitCn',
    'supportDataInfo.apiName.label': 'apiName',
    'supportDataInfo.apiName.holder': 'Enter apiName',
    'supportDataInfo.apiName.max': 'apiName max length: 255',
    'supportDataInfo.apiName.required': 'apiName required',
    'supportDataInfo.searchApiName.holder': 'Search apiName',
    'supportDataInfo.sysId.label': 'sysId',
    'supportDataInfo.sysId.holder': 'Enter sysId',
    'supportDataInfo.sysId.max': 'sysId max length: 50',
    'supportDataInfo.sysId.required': 'sysId required',
    'supportDataInfo.searchSysId.holder': 'Search sysId',
    'supportDataInfo.apiname.label': 'apiname',
    'supportDataInfo.apiname.holder': 'Enter apiname',
    'supportDataInfo.apiname.max': 'apiname max length: 50',
    'supportDataInfo.apiname.required': 'apiname required',
    'supportDataInfo.searchApiname.holder': 'Search apiname',
    'supportDataInfo.isShow.label': 'isShow',
    'supportDataInfo.isShow.holder': 'Enter isShow',
    'supportDataInfo.isShow.max': 'isShow max length: 10',
    'supportDataInfo.isShow.required': 'isShow required',
    'supportDataInfo.searchIsShow.holder': 'Search isShow',
    'supportDataInfo.qu.label': 'qu',
    'supportDataInfo.qu.holder': 'Enter qu',
    'supportDataInfo.qu.max': 'qu max length: 50',
    'supportDataInfo.qu.required': 'qu required',
    'supportDataInfo.searchQu.holder': 'Search qu',
    'supportDataInfo.isPage.label': 'isPage',
    'supportDataInfo.isPage.holder': 'Enter isPage',
    'supportDataInfo.isPage.max': 'isPage max length: 10',
    'supportDataInfo.isPage.required': 'isPage required',
    'supportDataInfo.searchIsPage.holder': 'Search isPage',
    'supportDataInfo.procId.label': 'procId',
    'supportDataInfo.procId.holder': 'Enter procId',
    'supportDataInfo.procId.max': 'procId max length: 10',
    'supportDataInfo.procId.required': 'procId required',
    'supportDataInfo.searchProcId.holder': 'Search procId',
    'supportDataInfo.browseNum.label': 'browseNum',
    'supportDataInfo.browseNum.holder': 'Enter browseNum',
    'supportDataInfo.browseNum.max': 'browseNum max length: 10',
    'supportDataInfo.browseNum.required': 'browseNum required',
    'supportDataInfo.searchBrowseNum.holder': 'Search browseNum',
    'supportDataInfo.downNum.label': 'downNum',
    'supportDataInfo.downNum.holder': 'Enter downNum',
    'supportDataInfo.downNum.max': 'downNum max length: 10',
    'supportDataInfo.downNum.required': 'downNum required',
    'supportDataInfo.searchDownNum.holder': 'Search downNum',
    'supportDataInfo.visitNum.label': 'visitNum',
    'supportDataInfo.visitNum.holder': 'Enter visitNum',
    'supportDataInfo.visitNum.max': 'visitNum max length: 10',
    'supportDataInfo.visitNum.required': 'visitNum required',
    'supportDataInfo.searchVisitNum.holder': 'Search visitNum'
  }
}
